import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ModalTermsComponent } from '../../../../../shared/modal-terms/modal-terms.component';
import { FormGroup } from '@angular/forms';
import { CreditCardService } from '../../../../../shared/cards/credit-card.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Auth } from '../../../../../autentication/Auth';
import { AutenticationService } from '../../../../../autentication/autentication.service';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../../../shared/EventTypes';

@Component({
	selector: 'app-cards-credit-activation-step2',
	templateUrl: './step2.component.html',
	styleUrls: ['./step2.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CardsCreditActivationStep2Component implements OnInit {
	public submittedForm = false;
	public form: FormGroup;
	public img: any;
	public submited = false;
	public contractChecked = false;
	public days = [
		{
			day: 1,
			label: '01',
			selected: true
		},
		{
			day: 5,
			label: '05',
			selected: false
		},
		{
			day: 10,
			label: '10',
			selected: false
		},
		{
			day: 15,
			label: '15',
			selected: false
		},
		{
			day: 20,
			label: '20',
			selected: false
		},
		{
			day: 25,
			label: '25',
			selected: false
		}
	];

	constructor(
		private router: Router,
		public dialog: MatDialog,
		private creditCardService: CreditCardService,
		private sanitizer: DomSanitizer,
		private autenticationService: AutenticationService,
	) {}

	ngOnInit(): void {
		this.getImgBannerCreditCard();
	}

	changeTerms(checked: boolean) {
		this.contractChecked = checked;
	}

	selectDay(day: any) {
		this.days.forEach(o => { o.selected = false; });
		day.selected = true;
	}

	openModal(): void {
		this.creditCardService.getTermsCreditCard().subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.dialog.open(ModalTermsComponent, {
					width: '700px',
					height: '500px',
					data: {
						title: 'Termos de contrato do cartão de crédito',
						text: data.Retorno.Texto
					}
				});
			}
		});
	}

	goToNextTab() {
		if (this.form.valid) {
			this.preload(true);
			this.addAuthToken();
			this.creditCardService.diaVencimento = this.days.find(x => x.selected).day;
			this.sendAssignature();
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.enableCreditCard();
			}
		}, error => {
			this.handleError(error);
		});
	}

	enableCreditCard() {
		this.creditCardService.enableCreditCard(this.creditCardService.diaVencimento).subscribe(data => {
			if (data.Sucesso) {
				this.preload(false);
				this.router.navigate(['cartoes-ativacao/credito/step3']);
			}
		}, error => {
			this.handleError(error);
		});
	}

	handleError(error) {
		this.preload(false);
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
	}

	preload(active: boolean, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, { element: '[data-component="cards-credit-activation-step2"]', show: active, delay: delay });
	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	getImgBannerCreditCard() {
		this.img = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.creditCardService.creditCardImg);
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
	}

	public getMessageConfirmedPasswords(message: boolean) {
		this.submittedForm = message;

		if (!this.contractChecked || this.form.invalid) {
			return;
		}

		this.goToNextTab();
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/cards-activation/credit/activation/step2/step2.component.ts